import { useReactiveVar } from "@apollo/client";
import { useEffect, useRef } from "react";
import { useMatchMedia } from "~/hooks/use-match-media";
import { profileIdVar } from "~/lib/apollo/link";
import { isLoadingGAVar, pageTypeVar } from "~/lib/tracking/store";
import { isLoadingAuthVar, useAuth } from "~/provider/auth";
import { request } from "~/util/request";

/**
 * @see https://confl.arms.dmm.com/pages/viewpage.action?pageId=201552262
 */
type RequestType = {
  message: string;
  status: string;
  tags: string;
};

export const Tracking = () => {
  const { isLoggedIn } = useAuth();
  const isLoadingAuth = useReactiveVar(isLoadingAuthVar);
  const { isPcSize } = useMatchMedia();
  const parentProfileId = useReactiveVar(profileIdVar);
  const pageType = pageTypeVar();

  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isLoadingAuth) return;

    let tag = "";
    (async () => {
      if (!ref.current) return;
      isLoadingGAVar(true);
      try {
        // MEMO（kimura） : axios で application/x-www-form-urlencoded の形式でリクエストを送るためには URLSearchParams でクエリパラメータに変換する必要がある
        // MEMO（kimura）: ひとまず木村はこのままにしておくが、これは確認が必要な案件かもしれない。正しく値を送れない可能性がある。なのでコメントは残しておく。
        // 参考文献 : https://axios-http.com/docs/urlencoded
        const response = await request.post<RequestType>(
          process.env.NEXT_PUBLIC_TRACKING_ENDPOINT,

          {
            url: "http://tv.dmm.com/",
            device: isPcSize ? "pc" : "sp",
            login: isLoggedIn ? 1 : 0,
            options: { i3: "1", gtm: "1", aff: "0" },
            profile_id: parentProfileId,
            page_type: pageType,
          },
          {
            headers: {
              accept: "application/json",
              "content-type": "application/x-www-form-urlencoded",
            },
            withCredentials: true,
            timeout: 500,
          }
        );
        tag = response.data.tags;
      } catch (e) {
        tag =
          '<div id="tracking_area"><script>window.i3 = window.i3 || function(a,b,c, callback) { if(callback && typeof callback === "function"){ callback(); } }</script></div>';
      } finally {
        const fragment = document.createRange().createContextualFragment(tag);
        ref.current.appendChild(fragment);
        isLoadingGAVar(false);
      }
    })();
  }, [isLoadingAuth]);

  return <div ref={ref} />;
};
